import type { Panel } from "./navigation"

export function panelNavigationTarget(panel: Panel, pathname: string, path: string) {
  const prefix = `/${panel}`
  const mounted = pathname === prefix || pathname.startsWith(prefix + "/")
  const prefixed = path === prefix || path.startsWith(prefix + "/")
  return mounted && !prefixed && path.startsWith("/") && !path.startsWith("//") ? prefix + path : path
}
